module.exports = "/_next/static/images/e80a564868cb74ab8ed2f8c958b80d3d-secured-card-magic.png.webp";